import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'cancel-reminder-modal',
  templateUrl: 'cancel-reminder-modal.component.html',
  styleUrls: ['cancel-reminder-modal.component.scss'],
  standalone: false
})
export class CancelReminderModalComponent {
  constructor(
    public dialogRef: MatDialogRef<CancelReminderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  yesButtonClicked() {
    return { cancel: true };
  }

  noButtonClicked() {
    return { cancel: false };
  }
}
